import ApiService from "vamos/cockpit/base/services/type/ApiService";
import BaseController from "vamos/cockpit/base/controller/type/BaseController";
import getText from "vamos/cockpit/base/handler/Text";
import { ResponsePdfStatusDto, ResponseString } from "vamos/cockpit/model/api/vamos.private.api.types";

import Dialog from "sap/m/Dialog";
import FileService from "vamos/cockpit/base/services/file/FileService";
import JSONModel from "sap/ui/model/json/JSONModel";
import AppResponse from "vamos/cockpit/model/api/AppResponse";

export default class PdfFileHandler {

    private controller: BaseController;

    private progressDialog: Dialog;

    private fileService: FileService;

    private statusInterval: NodeJS.Timeout | string | number | undefined;

    constructor(controller: BaseController) {
        this.controller = controller;
        const sFragmentName = "vamos.cockpit.base.view.fragments.ProgressDialog";
        this.progressDialog = this.controller.getXmlFragment(sFragmentName) as Dialog;
        this.progressDialog.attachAfterClose(() => {
            clearInterval(this.statusInterval);
        });
        this.fileService = new FileService(this.controller);
    }

    public async createFile(p_PathParam: string, p_arPayLoad: object, p_sFileName: string) {

        try {
            const appResponse: AppResponse<ResponseString> = await ApiService.getInstance().postRestJsonData(p_PathParam, p_arPayLoad);

            if (appResponse.success) {
                this.checkPdfStatus(appResponse.data.content, p_sFileName);
            }
        } catch (error) {
            console.error(error);
        }
    }


    private checkPdfStatus(pdfFileGuid: string, pdfFileName: string): void {
        this.progressDialog.setTitle(getText("PDF_PROGRESS_TITLE"));
        this.progressDialog.open();
        this.statusInterval = setInterval(() => {
            this.updateStatusDialog(pdfFileGuid, pdfFileName).then(() => {

            }).catch((e) => {
                console.log(e);
            });
        }, 1000);

    }

    private async updateStatusDialog(pdfFileGuid: string, pdfFileName: string) {
        const statusResponse: ResponsePdfStatusDto = await ApiService.getInstance().getRestJsonData(`/pdf/status/${pdfFileGuid}`);
        const pdfStatusDto = statusResponse.content;


        const oViewModel = this.controller.getModel("view") as JSONModel;
        const sStep = pdfStatusDto.currentStep;
        if (sStep === "FINISH_GENERATION") {
            clearInterval(this.statusInterval);
            this.progressDialog.close();
            await this.fileService.downloadPDFFile(`/pdf/download/${pdfFileGuid}`, pdfFileName, "pdf", true, () => {
                this.controller.getModel().refresh();
            });

        }
        const stepPercentage = statusResponse.content.currentStepCount / statusResponse.content.maxStepCount;
        const currentStepPercentage = (statusResponse.content.currentStepProgress / statusResponse.content.maxStepCount + stepPercentage) * 100;

        oViewModel.setProperty("/CurrentStep", getText("PDF_" + sStep));
        oViewModel.setProperty("/StepPercentage", currentStepPercentage);
        oViewModel.setProperty("/StepText", "");
    }

}